import {api} from "./api.service";

export const GetForumsService = async (id, param) => {
  let res = await api.get(`forumSubmission/get-submissions-by-forum/${id}`, {
    params: param,
  });
  return res;
};
export const GetForumUsers = async (id, param) => {
  let res = await api.get(`forum/members/${id}`, {
    params: param,
  });
  return res;
};
export const EditForumName = async (payload) => {
  let res = await api.patch(`forum/update-forum-name`, payload);
  return res;
};
export const EditForum = async (payload) => {
  let res = await api.post(`forumNotes`, payload);
  return res;
};
export const GetForumNotes = async () => {
  let res = await api.get(`/forumNotes/get-user-forum-notes`);
  return res;
};
export const GetForumResource = async (id) => {
  let res = await api.get(`forum/${id}`);
  return res;
};
export const DeleteForumService = async (id) => {
  let res = await api.delete(`forumSubmission/${id}`);
  return res;
};
export const CreateForumService = async (data, id) => {
  let res = await api.post(`forumSubmission/${id}`, data);
  return res;
};
